import { render } from "./AddJobPost.vue?vue&type=template&id=ddee69d0&scoped=true"
import script from "./AddJobPost.vue?vue&type=script&lang=js"
export * from "./AddJobPost.vue?vue&type=script&lang=js"

import "./AddJobPost.vue?vue&type=style&index=0&id=ddee69d0&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddee69d0"]])

export default __exports__